import { EVINCED_SEVERITIES } from '@evinced-private/ui-common';

import { CustomSeverityNames, resolveSeverityLabel } from '../../../../helpers/SeverityLabelHelper';

export const OTHER_SEVERITIES_COLUMN_LABEL = 'Other severities';

export const buildOtherSeveritiesTooltipText = (
	customSeverityNames: CustomSeverityNames = {}
): string => {
	const moderateLabel = resolveSeverityLabel(EVINCED_SEVERITIES.MODERATE, customSeverityNames);
	const minorLabel = resolveSeverityLabel(EVINCED_SEVERITIES.MINOR, customSeverityNames);
	const needsReviewLabel = resolveSeverityLabel(
		EVINCED_SEVERITIES.NEEDS_REVIEW,
		customSeverityNames
	);
	const bestPracticeLabel = resolveSeverityLabel(
		EVINCED_SEVERITIES.BEST_PRACTICE,
		customSeverityNames
	);

	// Deduplicate: e.g. when moderate + minor both map to the same custom label ("low")
	const uniqueLabels = [
		...new Set([moderateLabel, minorLabel, needsReviewLabel, bestPracticeLabel])
	];

	const lastLabel = uniqueLabels[uniqueLabels.length - 1];
	const leadingLabels = uniqueLabels.slice(0, -1);
	const labelList =
		leadingLabels.length > 0 ? `${leadingLabels.join(', ')}, and ${lastLabel}` : lastLabel;

	return `The number is the sum of all ${labelList} issues.`;
};
